/**
 * Get array of stars fill percentage
 * example: [1, 1, 0.5, 0, 0]
 */
export function getUnits(count, value, isPercentage) {
  var units = [];
  if (isPercentage) {
    var oneUnitWeight = 1 / count;
    var weight = 0;
    for (var i = 0; i < count; i++) {
      var unitValue = (value - weight) / oneUnitWeight;
      if (unitValue < 0) {
        unitValue = 0;
      }
      if (unitValue > 1) {
        unitValue = 1;
      }
      weight += oneUnitWeight;
      units.push(unitValue);
    }
    return units;
  }

  // value is selected stars count
  for (var _i = 0; _i < count; _i++) {
    var _unitValue = _i <= value ? 1 : 0;
    units.push(_unitValue);
  }
  return units;
}
export function getRatingValue(count, value, isPercentage) {
  var units = getUnits(count, value, isPercentage);

  // eslint-disable-next-line no-param-reassign
  return units.reduce(function (currentValue, sum) {
    return sum += currentValue;
  }, 0);
}